import { useContext } from 'react';
import classNames from 'classnames';

import { ConfigContext } from '@providers/ConfigProvider';
import { FilesContext } from '@providers/FilesProvider';
import Typography from '@components/atoms/Typography';
import ContentBox from '@components/atoms/ContentBox';
import { FormattedMessage } from 'utils/intl';

import messages from './Info.messages';
import classes from './Info.module.scss';

type Props = {
  className?: string;
  withoutInfo?: boolean;
};

const Info = ({ className, withoutInfo = false }: Props): JSX.Element => {
  const { contact } = useContext(ConfigContext);
  const { getPageImageConfigs } = useContext(FilesContext);
  const [group1, group2, group3, group4, group5] = getPageImageConfigs([
    'group1',
    'group2',
    'group3',
    'group4',
    'group5',
  ]);

  return (
    <div className={classNames(className, classes.wrapper)}>
      {!withoutInfo && (
        <div className={classes.infoSection}>
          <Typography variant="huge">{contact.name}</Typography>
          <Typography variant="body1">
            {contact.typeOfCompanyFull}
            <br />
            <br />
            {contact.addressWithoutCountry}
            <br />
            <FormattedMessage {...messages.companyData} values={{ nip: contact.nip, regon: contact.regon }} />
            <br />
            <br />
            {contact.registerInfo}
          </Typography>
        </div>
      )}
      <div className={classes.photos}>
        <ContentBox variant="image" resolveConfig={group1} alt="biuro" className={classes.first} />
        <ContentBox variant="image" resolveConfig={group2} alt="ludzie" className={classes.second} />
        <ContentBox variant="image" resolveConfig={group3} alt="sesja zdjęciowa" className={classes.third} />
        <ContentBox variant="image" resolveConfig={group4} alt="budynek cocon" className={classes.fourth} />
        <ContentBox variant="image" resolveConfig={group5} alt="odbieranie nagrody" className={classes.fifth} />
      </div>
    </div>
  );
};

export default Info;
